import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SectionLabel from "@/components/SectionLabel";
import Reveal from "@/components/Reveal";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.posts().then((r) => setPosts(r.posts)).catch(() => {}); }, []);
  return (
    <div className="max-w-site mx-auto px-6 md:px-10 py-16 md:py-24" data-testid="journal-page">
      <div className="mb-14">
        <SectionLabel index="01 / Journal">Letters from the lab.</SectionLabel>
        <h1 className="font-display text-5xl md:text-7xl tracking-[-0.03em] leading-[0.95] mt-6">
          Longform, <span className="editorial normal-case">on what actually works.</span>
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.05}>
            <Link to={`/journal/${p.slug}`} className="group block border border-[color:var(--line)] bg-[color:var(--bg)] hover:bg-[color:var(--bg-soft)] transition" data-testid={`journal-page-card-${i}`}>
              <div className="aspect-[4/3] bg-[color:var(--bg-soft)] overflow-hidden">
                <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition duration-700 group-hover:scale-[1.02]" />
              </div>
              <div className="p-6">
                <div className="label !text-[10px]">{p.category} · {p.read_time}</div>
                <h2 className="font-display text-2xl mt-3 tracking-[-0.01em]">{p.title}</h2>
                <p className="text-sm text-[color:var(--ink-2)] mt-2">{p.excerpt}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
